import {PickerColumn} from 'src/tracker/model/column/tracker-column'
import { pandemoniumProperty } from 'src/tracker/model/property/summon/pandemonium-property'

export const pandemoniumColumn = new PickerColumn(
  "85px",
  pandemoniumProperty,
)
